module.exports = __webpack_public_path__ + "static/media/parkmatch-light.72566bcc.png";